module.exports = __webpack_public_path__ + "3bb57a5cc78a1e0ae6b695f3d3e8128b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phonedemo.png
// module id = 173
// module chunks = 0